import navigationEn from './locales/en/navigation';
import navigationZhHant from './locales/zh-Hant/navigation';
import commonEn from './locales/en/common';
import commonZhHant from './locales/zh-Hant/common';
import overviewEn from './locales/en/overview';
import overviewZhHant from './locales/zh-Hant/overview';
import activityEn from './locales/en/activity';
import activityZhHant from './locales/zh-Hant/activity';
import settingsEn from './locales/en/settings';
import settingsZhHant from './locales/zh-Hant/settings';
import errorsEn from './locales/en/errors';
import errorsZhHant from './locales/zh-Hant/errors';
import sendEn from './locales/en/send';
import sendZhHant from './locales/zh-Hant/send';
import receiveEn from './locales/en/receive';
import receiveZhHant from './locales/zh-Hant/receive';
import swapEn from './locales/en/swap';
import swapZhHant from './locales/zh-Hant/swap';
import claimEn from './locales/en/claim';
import claimZhHant from './locales/zh-Hant/claim';
import bbtEn from './locales/en/bbt';
import bbtZhHant from './locales/zh-Hant/bbt';
import ggmomomoEn from './locales/en/ggmomomo';
import ggmomomoZhHant from './locales/zh-Hant/ggmomomo';
import wldEn from './locales/en/wld';
import wldZhHant from './locales/zh-Hant/wld';
import bubbleGameEn from './locales/en/bubbleGame';
import bubbleGameZhHant from './locales/zh-Hant/bubbleGame';
import flight404En from './locales/en/flight404';
import flight404ZhHant from './locales/zh-Hant/flight404';
import transferEn from './locales/en/transfer';
import transferZhHant from './locales/zh-Hant/transfer';

export const localeRegistry = {
  en: {
    label: 'English',
    translation: {
      navigation: navigationEn,
      common: commonEn,
      overview: overviewEn,
      activity: activityEn,
      settings: settingsEn,
      errors: errorsEn,
      send: sendEn,
      receive: receiveEn,
      swap: swapEn,
      claim: claimEn,
      bbt: bbtEn,
      ggmomomo: ggmomomoEn,
      wld: wldEn,
      bubbleGame: bubbleGameEn,
      flight404: flight404En,
      transfer: transferEn,
    },
  },
  'zh-Hant': {
    label: '繁體中文',
    translation: {
      navigation: navigationZhHant,
      common: commonZhHant,
      overview: overviewZhHant,
      activity: activityZhHant,
      settings: settingsZhHant,
      errors: errorsZhHant,
      send: sendZhHant,
      receive: receiveZhHant,
      swap: swapZhHant,
      claim: claimZhHant,
      bbt: bbtZhHant,
      ggmomomo: ggmomomoZhHant,
      wld: wldZhHant,
      bubbleGame: bubbleGameZhHant,
      flight404: flight404ZhHant,
      transfer: transferZhHant,
    },
  },
} as const;

type LocaleRegistry = typeof localeRegistry;

export const resources = Object.fromEntries(
  Object.entries(localeRegistry).map(([language, { translation }]) => [language, { translation }]),
) as {
  [Language in keyof LocaleRegistry]: { translation: LocaleRegistry[Language]['translation'] };
};

export type AppResources = typeof resources;
